/*
 *
 *  session sagas
 *
 */

import { call, take, put, all, delay, race } from "redux-saga/effects";
import { setAuthToken } from "../../helpers/index";
//race
import store2 from "store2";
import {
  VERIFY_SESSION,
  LOG_IN,
  LOG_OUT,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  OTP_APPROVE,
  OTP_SEND,
  VALIDATE_OTP,
  SIGN_UP,
  REWARD_ID_AUTHENTICATION,
} from "./constants";

import {
  verifySessionSuccess,
  verifySessionError,
  logInSuccess,
  logInError,
  logOutSuccess,
  logOutError,
  forgotPasswordSuccess,
  forgotPasswordError,
  resetPasswordSuccess,
  resetPasswordError,
  otpApproveSuccess,
  otpApproveError,
  otpSendSuccess,
  otpSendError,
  otpValidateSuccess,
  otpValidateError,
  signUpSuccess,
  signUpError,
  rewardIdAuthenticationList,
  rewardIdAuthenticationListSuccess,
  rewardIdAuthenticationListError,
} from "./actions";

import {
  verifySession,
  logIn,
  forgotPassword,
  resetPasswordAPI,
  otpApproveAPI,
  otpSendAPI,
  validateOtp,
  signUpDetails,
  rewardIdAuthenticationDetails,
} from "./remotes";

// const machineId = localStorage.getItem("MachineId");
// const authUserDetails = localStorage.getItem("authUser")
// const userDetails = JSON.parse(authUserDetails)
// const loginDeviceId = userDetails.deviceId
// //console.log(machineId, "machineId from api");
// //console.log(userDetails, "userDetails api")
// //console.log(loginDeviceId, "machineId from api")
// //console.log(authUserDetails, "authUserDetails")
export function* verifyInitialSessionSaga() {
  const secret = store2.get("secret");
  const location = (window.location && window.location.pathname) || "/";

  if (secret && !["/reset-password/"].includes(location)) {
    try {
      setAuthToken(secret);
      store2.set("secret", secret);
      const user = yield call(verifySession);
      yield put(verifySessionSuccess(user));
    } catch (error) {
      store2.remove("secret");
      store2.remove("authUser");
      window.location.reload();
    }
  } else {
    try {
      yield put(logOutSuccess());
    } catch (error) {
      yield put(logOutError(error));
    } finally {
      store2.remove("secret");
      store2.remove("authUser");
    }
  }
}

export function* verifySessionSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { secret } = yield take(VERIFY_SESSION);
    if (secret && !process.env.offline) {
      try {
        setAuthToken(secret);
        const user = yield call(verifySession);
        yield put(verifySessionSuccess(user));
      } catch (error) {
        yield put(verifySessionError("Session Expired!"));
      }
    }
  }
}

export function* loginSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { user, history } = yield take(LOG_IN);

    try {
      const response = yield call(logIn, user);
      // //console.log(response, "response");
      setAuthToken(
        response && response.sessionInfo && response.sessionInfo.token
      );
      yield delay(500);
      localStorage.setItem("secret", response.sessionInfo.token);
      localStorage.setItem("sessionUser", JSON.stringify(response));
      localStorage.setItem("authUser", response.data.data);
      // localStorage.setItem("empId", response.id);

      yield put(logInSuccess(response));

      // if (machineId !== loginDeviceId) {
      //   history.push("/otp-approve")
      // } else {
      history.push("/dashboard");
      // }
    } catch (error) {
      localStorage.setItem("error", error);
      yield put(
        logInError(
          (error && error.message) ||
            (error && typeof error === "string" && error) ||
            JSON.stringify(error)
        )
      );
    }
  }
}
export function* signUpSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { user, history } = yield take(SIGN_UP);

    try {
      const response = yield call(signUpDetails, user);

      yield delay(500);
      // //console.log(response.menu, "my own res");
      localStorage.setItem("secret", response.sessionInfo.token);
      localStorage.setItem("sessionUser", response);
      localStorage.setItem("empId", response.id);

      yield put(signUpSuccess(response));

      // if (machineId !== loginDeviceId) {
      //   history.push("/otp-approve")
      // } else {
      history.push("/dashboard");
      // }
    } catch (error) {
      // //console.log(error, "error");
      localStorage.setItem("error", error);
      yield put(
        signUpError(
          (error && error.message) ||
            (error && typeof error === "string" && error) ||
            JSON.stringify(error)
        )
      );
    }
  }
}

function* logOutSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { history } = yield take(LOG_OUT);

    try {
      yield put(logOutSuccess());
      history.push("/login");
      localStorage.setItem("menu", "");
    } catch (error) {
      yield put(logOutError(error));
    } finally {
      store2.remove("authUser");
      store2.remove("secret");
    }
  }
}

export function* forgotPasswordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { record } = yield take(FORGOT_PASSWORD);

    try {
      const result = yield call(forgotPassword, record);
      if (result) {
        yield put(forgotPasswordSuccess(result.message));
      } else {
        yield put(forgotPasswordError("Unable to send email"));
      }
    } catch (error) {
      yield put(forgotPasswordError("Unable to send email"));
    }
  }
}
//RESET PASSWORD
export function* resetPasswordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { reset_Password } = yield take(RESET_PASSWORD);
    // //console.log(reset_Password, "inside saga");
    try {
      const result = yield call(resetPasswordAPI, reset_Password);
      // //console.log(result, "api result");
      if (result) {
        yield put(resetPasswordSuccess(result.message));
      } else {
        yield put(resetPasswordError("Reset password record failed"));
      }
    } catch (error) {
      yield put(resetPasswordError("Reset password record failed"));
    }
  }
}
//OTP APprove
export function* otpApproveSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { otp_approve } = yield take(OTP_APPROVE);
    //console.log(otp_approve, "inside saga");
    try {
      const result = yield call(otpApproveAPI, otp_approve);
      //console.log(result, "api result");
      if (result) {
        yield put(otpApproveSuccess(result.message));
      } else {
        yield put(otpApproveError("Otp Approve failed"));
      }
    } catch (error) {
      yield put(otpApproveError("Otp Approve failed"));
    }
  }
}

//OTP APprove
export function* otpSendSaga() {
  while (true) {
    const { mobile } = yield take(OTP_SEND);
    // //console.log(otp_sending, "otp_sending inside saga")
    try {
      const result = yield call(otpSendAPI, mobile);
      //console.log(result, "api result");
      if (result) {
        yield put(otpSendSuccess(result.message));
      } else {
        yield put(otpSendError("Otp sending failed"));
      }
    } catch (error) {
      yield put(otpSendError("Otp sending failed"));
    }
  }
}

function* rewardIdAuthenticationDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(REWARD_ID_AUTHENTICATION),
    });

    const { explicitLoad } = load;
    const { rewardId } = explicitLoad || {};
    yield put(rewardIdAuthenticationList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(rewardIdAuthenticationDetails, rewardId);
        //console.log(result, "result");
        if (result) {
          yield put(rewardIdAuthenticationListSuccess(result));
          //console.log(result, "result");
        }
      } catch (error) {
        yield put(
          rewardIdAuthenticationListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

//OTP APprove
export function* otpValidateSaga() {
  while (true) {
    const { user } = yield take(VALIDATE_OTP);
    // //console.log(otp_sending, "otp_sending inside saga")
    try {
      const result = yield call(validateOtp, user);
      //console.log(result, "api result");
      if (result) {
        yield put(otpValidateSuccess(result.message));

        //console.log(result, "result data");
      } else {
        yield put(otpValidateError("Otp sending failed"));
      }
    } catch (error) {
      yield put(otpValidateError("Otp sending failed"));
    }
  }
}

//reset password

export default function* rootSaga() {
  yield all([
    verifyInitialSessionSaga(),
    rewardIdAuthenticationDetailsSaga(),
    verifySessionSaga(),
    loginSaga(),
    signUpSaga(),
    logOutSaga(),
    forgotPasswordSaga(),
    resetPasswordSaga(),
    otpApproveSaga(),
    otpSendSaga(),
    otpValidateSaga(),
  ]);
}
